module.exports = __webpack_public_path__ + "static/media/LaffyBrainstorm.f62c881c.jpg";